import { motion } from "framer-motion";
import { Link } from "wouter";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

const fadeUp = {
  initial: { opacity: 0, y: 22 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: "easeOut" },
  viewport: { once: false, amount: 0.35 },
};

const floaty = {
  animate: { y: [0, 18, 0], rotate: [0, 6, 0] },
  transition: { duration: 10, repeat: Infinity, ease: "easeInOut" },
};

export default function SEO() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-white text-slate-900">
      <Navigation />

  {/* ================= SEO HERO (LIGHT PREMIUM WOW) ================= */}
{/* ================= SEO HERO (LIGHT PREMIUM WOW) ================= */}
<section className="relative isolate overflow-hidden">
  {/* Background base */}
  <div className="absolute inset-0 bg-gradient-to-b from-white via-slate-50 to-white" />

  {/* Soft spotlight - Mobile ke liye optimize */}
  <div className="absolute -top-24 left-1/2 h-[280px] w-[380px] sm:h-[400px] sm:w-[620px] md:h-[520px] md:w-[820px] -translate-x-1/2 rounded-full bg-gradient-to-r from-blue-200/35 via-cyan-200/25 to-purple-200/25 blur-3xl" />
  <div className="absolute -bottom-20 -left-20 h-[280px] w-[280px] sm:h-[400px] sm:w-[400px] md:h-[520px] md:w-[520px] rounded-full bg-gradient-to-tr from-blue-200/35 to-cyan-200/25 blur-3xl" />
  <div className="absolute -bottom-32 -right-32 h-[320px] w-[320px] sm:h-[500px] sm:w-[500px] md:h-[620px] md:w-[620px] rounded-full bg-gradient-to-tr from-purple-200/25 to-pink-200/20 blur-3xl" />

  {/* Subtle grid */}
  <div
    className="absolute inset-0 opacity-[0.05]"
    style={{
      backgroundImage:
        "linear-gradient(90deg, rgba(15,23,42,0.08) 1px, transparent 1px), linear-gradient(180deg, rgba(15,23,42,0.08) 1px, transparent 1px)",
      backgroundSize: "40px 40px",
    }}
  />

  {/* Noise overlay */}
  <div
    className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-multiply"
    style={{
      backgroundImage:
        "url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22140%22 height=%22140%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22140%22 height=%22140%22 filter=%22url(%23n)%22 opacity=%220.25%22/%3E%3C/svg%3E')",
    }}
  />

  <div className="relative z-10">
    {/* YAHAN MAIN CHANGE KIYA HAI - Mobile ke liye sirf top padding kam */}
    <div className="container mx-auto px-4 sm:px-6 pt-8 md:pt-16 lg:pt-20 pb-12 md:pb-16 lg:pb-20">
      {/* Hero grid - Mobile par stack */}
      <div className="grid items-center gap-8 md:gap-12 lg:grid-cols-2">
        {/* Left content */}
        <motion.div {...fadeUp}>
          {/* Premium badge */}
          <div className="inline-flex items-center gap-1.5 sm:gap-2 rounded-full border border-blue-200/60 bg-white/70 px-3 py-1.5 sm:px-4 sm:py-2 backdrop-blur-md shadow-sm">
            <span className="h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-gradient-to-r from-blue-600 to-cyan-500" />
            <span className="text-[10px] xs:text-xs font-bold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-blue-700">
              Premium SEO Services
            </span>
            <span className="h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-gradient-to-r from-cyan-500 to-blue-600" />
          </div>

          <h1 className="mt-4 sm:mt-6 text-2xl xs:text-3xl sm:text-4xl md:text-4xl lg:text-5xl font-extrabold leading-tight sm:leading-[1.05] tracking-tight">
            Long-Lasting Growth for{" "}
            <span className="bg-gradient-to-r from-blue-700 via-cyan-600 to-blue-700 bg-clip-text text-transparent">
              SEO Visibility
            </span>
          </h1>

          <p className="mt-4 sm:mt-6 text-sm sm:text-base md:text-lg text-slate-600 leading-relaxed max-w-xl">
            Variable Soft helps you rank with strategies that don't vanish after
            an update. We build authority, technical excellence, and content that
            converts — for sustainable organic growth.
          </p>

          {/* Feature chips - Mobile par wrap properly */}
          <div className="mt-6 sm:mt-8 flex flex-wrap gap-2 sm:gap-3">
            {[
              "Technical SEO Audit",
              "Content & Topic Clusters",
              "Local SEO",
              "Link Building",
              "Analytics & Reporting",
            ].map((chip, i) => (
              <motion.span
                key={chip}
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="inline-flex items-center gap-1.5 sm:gap-2 rounded-full border border-slate-200 bg-white/70 px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-semibold text-slate-700 shadow-sm hover:shadow-md hover:border-blue-200 transition-all"
              >
                <span className="h-1.5 w-1.5 sm:h-2 sm:w-2 rounded-full bg-gradient-to-r from-blue-600 to-cyan-500" />
                {chip}
              </motion.span>
            ))}
          </div>

          {/* CTA - Mobile par full width */}
          <div className="mt-6 sm:mt-8 md:mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link href="/getintouch">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.97 }}
                className="group relative w-full px-5 py-3.5 sm:px-7 sm:py-4 rounded-xl sm:rounded-2xl font-semibold text-white shadow-[0_18px_50px_-18px_rgba(37,99,235,0.55)]
                           bg-gradient-to-r from-blue-700 via-blue-600 to-cyan-500 overflow-hidden"
              >
                <span className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/35 to-transparent group-hover:translate-x-full transition-transform duration-1000" />
                </span>
                <span className="relative flex items-center justify-center gap-2">
                  <i className="fas fa-comments text-sm sm:text-base" />
                  <span className="text-sm sm:text-base">Talk to our Experts</span>
                </span>
              </motion.button>
            </Link>
          </div>

          {/* Mini trust row - Mobile par wrap aur text size */}
          <div className="mt-6 sm:mt-8 md:mt-10 flex flex-wrap items-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm text-slate-500">
            <div className="flex items-center gap-1.5 sm:gap-2">
              <i className="fas fa-shield-alt text-blue-600 text-sm" />
              <span>White-hat & Safe SEO</span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2">
              <i className="fas fa-bolt text-cyan-600 text-sm" />
              <span>Fast On-Page Wins</span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2">
              <i className="fas fa-star text-blue-700 text-sm" />
              <span>Conversion-First</span>
            </div>
          </div>
        </motion.div>

        {/* Right visual card - Mobile padding aur sizing */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.35 }}
          transition={{ duration: 0.9, ease: "easeOut" }}
          className="relative mt-8 md:mt-0"
        >
          {/* Glass wrapper */}
          <div className="relative rounded-2xl sm:rounded-3xl border border-slate-200 bg-white/70 backdrop-blur-xl shadow-[0_20px_60px_-30px_rgba(2,132,199,0.45)] sm:shadow-[0_35px_90px_-45px_rgba(2,132,199,0.45)] overflow-hidden">
            {/* top gradient bar */}
            <div className="h-1.5 sm:h-2 w-full bg-gradient-to-r from-blue-700 via-cyan-500 to-purple-500" />

            <div className="p-4 sm:p-6 md:p-7 lg:p-8">
              <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3 sm:gap-4">
                <div>
                  <div className="text-[10px] xs:text-xs sm:text-xs font-bold uppercase tracking-[0.15em] sm:tracking-[0.22em] text-slate-500">
                    SEO Performance Snapshot
                  </div>
                  <div className="mt-1 sm:mt-2 text-lg sm:text-xl md:text-2xl font-extrabold text-slate-900">
                    Organic Growth Engine
                  </div>
                  <div className="mt-0.5 sm:mt-1 text-xs sm:text-sm text-slate-600">
                    Ranking + Traffic + Leads (monthly)
                  </div>
                </div>

                <div className="self-start rounded-xl sm:rounded-2xl border border-slate-200 bg-white px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-bold text-blue-700 shadow-sm">
                  +{new Date().getFullYear()}
                </div>
              </div>

              {/* KPI grid - Mobile par gap kam */}
              <div className="mt-5 sm:mt-6 md:mt-7 grid grid-cols-2 gap-2 sm:gap-3 md:gap-4">
                {[
                  { value: "98%", label: "Success Rate", icon: "fa-check-circle" },
                  { value: "24/7", label: "Monitoring", icon: "fa-satellite-dish" },
                  { value: "300+", label: "Keywords Ranked", icon: "fa-key" },
                  { value: "40%", label: "Avg. Traffic Boost", icon: "fa-arrow-trend-up" },
                ].map((kpi, idx) => (
                  <motion.div
                    key={kpi.label}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: false, amount: 0.3 }}
                    transition={{ duration: 0.5, delay: 0.08 * idx }}
                    className="group rounded-xl sm:rounded-2xl border border-slate-200 bg-white/75 p-2 sm:p-3 md:p-4 shadow-sm hover:shadow-md hover:border-blue-200 transition-all"
                  >
                    <div className="flex items-center justify-between">
                      <div className="text-lg sm:text-xl md:text-2xl font-extrabold bg-gradient-to-r from-blue-700 to-cyan-600 bg-clip-text text-transparent">
                        {kpi.value}
                      </div>
                      <div className="h-8 w-8 sm:h-9 sm:w-9 md:h-10 md:w-10 rounded-xl sm:rounded-2xl border border-slate-200 bg-white flex items-center justify-center shadow-sm group-hover:border-blue-200 transition-colors">
                        <i className={`fas ${kpi.icon} text-blue-700 text-sm sm:text-base`} />
                      </div>
                    </div>
                    <div className="mt-1 sm:mt-2 text-[10px] xs:text-xs font-bold uppercase tracking-[0.15em] sm:tracking-[0.2em] text-slate-500">
                      {kpi.label}
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* mini chart illusion */}
              <div className="mt-4 sm:mt-5 md:mt-6 rounded-xl sm:rounded-2xl border border-slate-200 bg-white/80 p-3 sm:p-4 md:p-5 shadow-sm">
                <div className="flex items-center justify-between">
                  <div className="text-xs sm:text-sm font-bold text-slate-800">
                    Visibility Trend
                  </div>
                  <div className="text-[10px] xs:text-xs font-semibold text-slate-500">
                    Last 6 months
                  </div>
                </div>

                <div className="mt-3 sm:mt-4 grid grid-cols-12 gap-1 sm:gap-1.5 md:gap-2 items-end h-16 sm:h-20 md:h-24">
                  {[38, 46, 52, 60, 72, 82, 70, 78, 88, 92, 96, 100].map((h, i) => (
                    <motion.div
                      key={i}
                      initial={{ height: 10, opacity: 0.7 }}
                      whileInView={{ height: `${h}%`, opacity: 1 }}
                      viewport={{ once: false, amount: 0.4 }}
                      transition={{ duration: 0.6, delay: i * 0.03 }}
                      className="rounded sm:rounded-lg bg-gradient-to-t from-blue-700 to-cyan-500 shadow-[0_10px_30px_-18px_rgba(2,132,199,0.65)]"
                    />
                  ))}
                </div>

                <div className="mt-2 sm:mt-3 flex items-center justify-between text-[10px] xs:text-xs text-slate-500">
                  <span>More impressions</span>
                  <span>More leads</span>
                </div>
              </div>
            </div>

            {/* corner glow - Mobile ke liye chota */}
            <div className="pointer-events-none absolute -top-12 -right-12 h-32 w-32 sm:h-48 sm:w-48 md:h-64 md:w-64 rounded-full bg-gradient-to-tr from-cyan-300/30 to-blue-300/10 blur-2xl sm:blur-3xl" />
          </div>

          {/* floating note - Mobile positioning */}
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.35 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="absolute -bottom-4 left-3 right-3 sm:left-4 sm:right-4 md:left-6 md:right-6 rounded-xl sm:rounded-2xl border border-slate-200 bg-white/80 backdrop-blur-xl shadow-lg p-3 sm:p-4"
          >
            <div className="flex items-start gap-2 sm:gap-3">
              <div className="h-8 w-8 sm:h-9 sm:w-9 md:h-10 md:w-10 rounded-xl sm:rounded-2xl bg-gradient-to-r from-blue-700 to-cyan-500 text-white flex items-center justify-center shadow-md">
                <i className="fas fa-magic text-sm" />
              </div>
              <div>
                <div className="text-xs sm:text-sm font-extrabold text-slate-900">
                  Strategy that compounds
                </div>
                <div className="text-[10px] xs:text-xs text-slate-600 mt-0.5 sm:mt-1">
                  We focus on long-term authority + conversion-driven SEO, not quick hacks.
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  </div>
</section>      <Footer />
    </div>
  );
}
